<p class="inline-message text-header multiline text-center p-t-sm p-b-sm p-r-xl p-l-xl">
  <ng-content></ng-content>
</p>
